export default __webpack_public_path__ + "static/media/eye.8b7294a2.svg";